<template>
	<v-skeleton-loader v-if="loading" v-bind="loader" width="100%" type="card"></v-skeleton-loader>
	<v-form
		v-else
		class="security-form"
		ref="form"
		v-model="valid"
		lazy-validation
		@submit.prevent="validateAndSubmit"
	>
		<v-row>
			<v-col cols="12">
				<v-card-title class="security-form__title pt-0 pl-0 mb-5"
					>Change Password</v-card-title
				>
				<div class="d-flex justify-space-between align-baseline">
					<v-subheader class="security-form__description pl-0" disabled>
						Current password
					</v-subheader>

					<v-text-field
						dense
						outlined
						:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
						:rules="rules.password"
						:type="showPassword ? 'text' : 'password'"
						@click:append="showPassword = !showPassword"
						v-model="fields.current_password"
						:error-messages="field_errors.current_password"
						class="security-form__password"
					></v-text-field>
				</div>

				<div class="d-flex justify-space-between align-baseline">
					<v-subheader class="security-form__description pl-0" disabled>
						New Password
					</v-subheader>
					<v-text-field
						dense
						outlined
						:append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
						:rules="rules.password.concat(passwordComparisonRule)"
						:type="showNewPassword ? 'text' : 'password'"
						class="security-form__password"
						@click:append="showNewPassword = !showNewPassword"
						:error-messages="field_errors.new_password"
						v-model="fields.new_password"
					></v-text-field>
				</div>

				<div class="d-flex justify-space-between align-baseline mb-8">
					<v-subheader class="security-form__description pl-0" disabled>
						Confirm password
					</v-subheader>
					<v-text-field
						dense
						outlined
						class="security-form__password"
						:append-icon="showRePassword ? 'mdi-eye' : 'mdi-eye-off'"
						:type="showRePassword ? 'text' : 'password'"
						v-model="fields.new_confirm_password"
						required
						:rules="rules.password.concat(passwordConfirmationRule)"
						:error-messages="field_errors.new_confirm_password"
						@click:append="showRePassword = !showRePassword"
					>
					</v-text-field>
				</div>
				<p v-for="(error, index) in errors" :key="index" class="text-danger">
					{{ error }}
				</p>
				<v-divider class="security-form__divider mt-8 mb-8"></v-divider>
				<v-btn
					class="d-flex rounded-pill text-capitalize security-form__button"
					@click="validateAndSubmit"
					:loading="loading"
					>Change
				</v-btn>
			</v-col>
		</v-row>
	</v-form>
</template>

<script>
import { mapActions } from 'vuex'

import { rulePassword, ruleRequired } from '@/utils/rules'

import Form from '@/mixins/Form'

export default {
	name: 'SecurityForm',
	mixins: [Form],
	data() {
		return {
			fields: {
				current_password: '',
				new_password: '',
				new_confirm_password: '',
			},
			showNewPassword: false,
			showPassword: false,
			showRePassword: false,
			loader: {
				class: 'mb-6',
				boilerplate: true,
				elevation: 2,
			},
		}
	},
	computed: {
		passwordComparisonRule() {
			return () =>
				this.fields.current_password !== this.fields.new_password ||
				'New password must do not repeat old password.'
		},
		passwordConfirmationRule() {
			return () =>
				this.fields.new_password === this.fields.new_confirm_password ||
				'Password must match'
		},
		rules() {
			return {
				password: [
					(v) => ruleRequired(v) || 'Field is required.',
					(v) => rulePassword(v) || 'Password must contain a minimum of 8 characters.',
				],
			}
		},
	},
	methods: {
		...mapActions('settings', ['changePassword']),
		submitForm() {
			this.field_errors = {}
			return this.changePassword(this.fields)
		},
	},
}
</script>

<style lang="scss">
.security-form {
	max-width: 555px;

	.v-input__slot::before {
		border-style: none !important;
	}

	.v-input {
		font-weight: 500;
		font-size: 22px;
		color: #cbcbcb;
		opacity: 1;
	}

	input::placeholder {
		font-weight: 600;
		font-size: 22px;
		color: #cbcbcb !important;
		opacity: 1;
	}

	&__title {
		font-style: normal;
		font-weight: 700;
		font-size: 20px;
		letter-spacing: 0.1px;
		color: #202232;
	}

	&__password {
		max-width: 55% !important;
	}

	&__description {
		font-style: normal;
		font-weight: 500;
		font-size: 18px;
		line-height: 67px;
		color: #cbcbcb !important;
	}

	&__avatar {
		width: 70px;
		height: 70px;
	}

	&__image-input {
		border-radius: 25px;
		cursor: pointer;
	}

	&__button {
		height: 30px !important;
		max-width: 132px !important;
		width: 132px !important;
		border: 1px solid #4d536e;
		font-style: normal !important;
		font-weight: 600;
		font-size: 15px;
		line-height: 18px;
		background-color: white !important;
		box-shadow: none;
		text-align: center;
		letter-spacing: -0.28px;

		&:hover {
			color: #fff !important;
			background: #4d536e !important;
		}
	}

	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}
}
</style>
